<script lang="typescript">
  // components
  import ResultsTable from './ResultsTable.svelte';

  // types
  import type { Readable } from 'svelte/store';
  import type { RaceInterface } from '../interfaces';

  export let race: Readable<RaceInterface>;

  $: caption =
    $race.office === 'I' ? `${$race.name} ${$race.seat_name}` : $race.seat_name;
</script>

<ResultsTable
  {caption}
  raceId={$race.id}
  captionNote={$race.description}
  candidates={$race.candidates}
  totalVotes={$race.total_votes}
  office={$race.office}
  precinctsReportingPercent={$race.precincts_reporting_percent}
  eevp={$race.eevp} />
